export function TitleCell({ value }: { value: string | null }) {
  return <>{value ?? "-"}</>;
}
